import React from 'react';
import { TransportMode } from '../types';

interface Props {
  selectedModes: TransportMode[];
  onChange: (modes: TransportMode[]) => void;
}

const MODES: { value: TransportMode; label: string; icon: string }[] = [
  { value: 'walking', label: 'A piedi', icon: '🚶' },
  { value: 'transit', label: 'Mezzi pubblici', icon: '🚌' },
  { value: 'driving', label: 'Auto', icon: '🚗' },
  { value: 'bicycling', label: 'Bicicletta', icon: '🚲' },
];

const TransportSelector: React.FC<Props> = ({ selectedModes, onChange }) => {
  const toggleMode = (mode: TransportMode) => {
    if (selectedModes.includes(mode)) {
      // Don't allow deselecting the last mode
      if (selectedModes.length > 1) {
        onChange(selectedModes.filter(m => m !== mode));
      }
    } else {
      onChange([...selectedModes, mode]);
    }
  };

  return (
    <div className="transport-selector">
      <label className="field-label">Mezzi disponibili *</label>
      <div className="transport-grid">
        {MODES.map(mode => (
          <button
            key={mode.value}
            type="button"
            className={`transport-chip ${selectedModes.includes(mode.value) ? 'active' : ''}`}
            onClick={() => toggleMode(mode.value)}
            aria-pressed={selectedModes.includes(mode.value)}
          >
            <span className="transport-icon">{mode.icon}</span>
            <span className="transport-label">{mode.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default TransportSelector;
